import { ApiService } from "@/api";

export const getAllTelpIntvSampleList = (county: string) => {
  return ApiService.baseAction(
    `sample-telephone-interview/${county}/all`,
    {},
    "get"
  );
};
